"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
// Commponent
var Dashboard_vue_1 = __importDefault(require("./Components/Dashboard.vue"));
// Models
var Dashboard_1 = require("./Models/Dashboard");
var DashboardPhaseGroupes_1 = require("./Models/DashboardPhaseGroupes");
require("./profilListe");
var moment_addon_1 = __importDefault(require("../Addons/moment-addon"));
$.initDashboard = function () {
    var $dashboard = $("#dashboard-affaire");
    if ($dashboard.length === 0) {
        return;
    }
    new vue_1.default({
        el: $dashboard[0],
        data: new Dashboard_1.Dashboard(),
        components: {
            "dashboard": Dashboard_vue_1.default
        },
        mounted: function mounted() {
            var _this = this;
            $.ajax({
                url: '/Home/GetDashboardGroupesTasks'
            }).done(function (result) {
                _this.$data.phaseGroupes = result.map(function (grp) {
                    return new DashboardPhaseGroupes_1.DashboardPhaseGroupes(grp);
                });
                _this.$root.$data.showLoader = false;
            });
        }
    });
};
$.initPortefeuille = function () {
    var $portefeuille = $("#portefeuille-affaire");
    if ($portefeuille.length === 0) {
        return;
    }
    var $dt = $(".affaire-datatable");
    $("#excelExport").off().on("click", function () {
        $dt.downloadCsv("/Affaires/DownloadDatatableCsv");
    });
    $dt.find("table").on('processing.dt', function (e, settings, processing) {
        $('.datatable-processing').css('display', processing ? 'block' : 'none');
        $.addOrRemoveOverflow();
    });
    $dt.setDatatable();
    $(window).on("resize", function () {
        $.addOrRemoveOverflow();
    });
    $("div.row-dashboard").on("change", function () {
        if ($dt.length <= 0) {
            $.addOrRemoveOverflow();
        }
    });
    $(".save-profil-liste-affaire").profilListAffaires();
    $(".select-profil-liste-affaire").selectProfilListAffaires();
};
$.addOrRemoveOverflow = function () {
    var $dt = $(".affaire-datatable"),
        $boxBusiness = $("div.boxBusiness"),
        $ctrlToCheck = $dt.length > 0 ? $dt : $boxBusiness.find(">div.row:first");
    if ($ctrlToCheck.outerHeight(true) > $boxBusiness.outerHeight()) {
        $boxBusiness.css("overflow-y", "scroll");
    } else {
        $boxBusiness.css("overflow-y", "unset");
    }
};
$.initBoxAgenda = function () {
    var $picker = $("#boxAgenda");
    if ($picker.length === 0) {
        return;
    }
    $picker.datetimepicker({
        inline: true,
        collapse: false,
        viewMode: "days",
        format: "DD/MM/YYYY"
    });
    var loadDates = function loadDates() {
        var $days = $picker.find("td.day");
        var minDateTime = $days.first().data("day") + " 00:00:00";
        var maxDateTime = $days.last().data("day") + " 23:59:59";
        var inputFormat = "DD/MM/YYYY";
        var outputFormat = "YYYY-MM-DD HH:mm:SS";
        $.getJSON("/Home/GetDatesForAgenda?minDateTime=" + moment_addon_1.default(minDateTime, inputFormat).format(outputFormat) + "&maxDateTime=" + moment_addon_1.default(maxDateTime, inputFormat).format(outputFormat), function (days) {
            // On ajoute le tooltip et l'action aux dates
            $days.each(function (i, el) {
                var $el = $(el),
                    day = days.find(function (d) {
                    return $el.data("day") === d.day;
                });
                if (day) {
                    $el.addClass("highlight " + day.cssClass);
                    $el.attr("title", day.label);
                    if (day.url) {
                        $el.on("click", function () {
                            return location.replace(day.url);
                        });
                    }
                }
            });
        });
    };
    loadDates();
    $picker.on("dp.update", function (e) {
        return loadDates();
    });
};
$.initIndicateurs = function () {
    var $indicContainer = $(".box-indicateurs-header .indicateurs-light");
    if ($indicContainer.length === 0) {
        return;
    }
    $.get("/Home/GetDashbBardIndicateurs", function (data) {
        var $parent = $("> div.row:first", $indicContainer);
        $parent.find("div.processing").remove();
        $parent.append(data);
    });
};
$.initDashboard();
$.initPortefeuille();
$.initBoxAgenda();
$.initIndicateurs();


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Dashboard/index.ts
// module id = 525
// module chunks = 0